import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {CookieService} from "ngx-cookie-service";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private apiUrl = environment.athenaApiUrl; // L'URL de ton API backend
  private tokenKey = 'authToken'; // La clé pour stocker le token
  // BehaviorSubject pour l'état d'authentification
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  constructor(private http: HttpClient, private cookieService: CookieService) {
    // Initialiser l'état d'authentification ici pour vérifier s'il y a déjà un token
    if (this.hasToken()) {
      this.isAuthenticatedSubject.next(true);
    }
  }


  // Méthode pour se connecter et récupérer le token en utilisant Basic Auth
  login(username: string, password: string): Observable<any> {
    const body = {
      username: username,
      password: password
    };

    return this.http.post<{ token: string }>(`${this.apiUrl}/athena/login`, body);
  }

  // Méthode pour stocker le token dans un cookie
  storeToken(token: string): void {
    this.cookieService.set(this.tokenKey, token, 1, '/', '', true, 'Strict'); // Le cookie dure 1 jour, Secure et SameSite strict
    this.isAuthenticatedSubject.next(true);
  }

  // Méthode pour vérifier si un token existe dans le cookie
  private hasToken(): boolean {
    return !!this.cookieService?.get(this.tokenKey);
  }

  // Méthode pour retourner le token
  getToken(): string {
    return this.cookieService?.get(this.tokenKey);
  }

  // Méthode pour se déconnecter (supprimer le cookie)
  logout(): void {
    this.cookieService.delete(this.tokenKey, '/');
    this.isAuthenticatedSubject.next(false); // Met à jour l'état à déconnecté
  }
}
